// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__P5dg0","header":"ReportDetails_header__3Q080","title":"ReportDetails_title__2v7_c","left":"ReportDetails_left__1dXZX"};